import { queryOptions } from "@tanstack/react-query";
import { getGoodsInfo } from "@/apis/pricing"

export const pricingGoogsQueryOption = (type) => queryOptions({
  queryKey: ['pricing', 'goods', type],
  queryFn: () => getGoodsInfo({ type })
})